"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useTimeout = useTimeout;
var react_1 = require("react");
function useTimeout() {
    var timeoutsRef = (0, react_1.useRef)(new Set());
    (0, react_1.useEffect)(function () { return function () { return timeoutsRef.current.forEach(function (timeout) { return clearTimeout(timeout); }); }; }, []);
    return function (callback, ms) {
        var args = [];
        for (var _i = 2; _i < arguments.length; _i++) {
            args[_i - 2] = arguments[_i];
        }
        var timeout = setTimeout.apply(void 0, __spreadArray([function () {
                var args = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    args[_i] = arguments[_i];
                }
                timeoutsRef.current.delete(timeout);
                return callback.apply(void 0, args);
            },
            ms], args, false));
        timeoutsRef.current.add(timeout);
        return timeout;
    };
}
